import { useQueries } from '@tanstack/react-query';
import qs from 'qs';

import { OPERATIONS_PAGINATION_URL } from 'utils/api';
import { toastr } from 'react-redux-toastr';

import api from 'core/api';
import { normalizeTradeIdeaOperations } from '../normalizer/normalizeOperations';

async function fetchOperationsFilter({
  PaginaAtual,
  TipoOperacao,
  Menu,
  filters,
}) {
  const { Ativos, CategoriasAtivo, Estruturas, PapelIncluso, TiposEstrategia, Vencimentos } = filters;
  try {
    const { data } = await api.get(`${OPERATIONS_PAGINATION_URL}/paginacao`, {
      params: {
        PaginaAtual,
        TipoOperacao,
        Menu,
        Ativos,
        CategoriasAtivo,
        Estruturas,
        PapelIncluso,
        TiposEstrategia,
        Vencimentos,
      },
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'comma' }),
    });
    return { key: 'operations', data };
  } catch (error) {
    toastr.error('Filtro de Operações', 'Ops... Ocorreu algum problema!');
    return { key: 'operations', data: null };
  }
}

async function fetchTradeIdeaFilter(currentPage, type) {
  const query = await api.get('/tradeidea', { params: {
    Pagina: currentPage,
    TamanhoPagina: 21,
    Tipo: type,
  } }).then(({ data }) => {
    const normalized = normalizeTradeIdeaOperations(data);
    return { values: normalized, responseData: data };
  }).catch(() => {
    toastr.error('Filtro de Operações', 'Ops... Ocorreu algum problema!');
  });

  return { key: 'trade idea filter', data: query };
}

function useFetchOperationsWithFilter(filter) {
  const data = useQueries({ queries:
    [
      {
        queryKey: ['operations', filter],
        queryFn: () => fetchOperationsFilter(filter),
        enabled: filter.Menu !== 'novas operações',
      },
      {
        queryKey: ['novas operações filter', filter],
        queryFn: () => fetchTradeIdeaFilter(filter.PaginaAtual, filter.TipoOperacao),
        enabled: filter.Menu === 'novas operações',
      },
    ] });

  const findByKey = key => data.find(item => item.data?.key === key);

  const isLoading = data.some(result => result.isLoading && result.fetchStatus !== 'idle');


  const queryData = filter.Menu !== 'novas operações' ? {
    currentPage: findByKey('operations')?.data?.data?.paginacao.paginaAtual || 0,
    pageCount: findByKey('operations')?.data?.data?.paginacao.paginaAtual || 0,
    data: findByKey('operations')?.data?.data?.operacoes || [],
    dataFilter: findByKey('operations')?.data?.data?.filtro,
    isLoading,
  } : {
    currentPage: findByKey('trade idea filter')?.data?.data?.responseData?.informacoesPagina?.paginaAtual || 0,
    pageCount: Math.ceil(findByKey('trade idea filter')?.data?.data?.responseData?.informacoesPagina.quantidadeRegistros / 21) || 0,
    data: findByKey('trade idea filter')?.data?.data?.values || [],
    dataFilter: [],
    isLoading,
  };

  return queryData;
}

export default useFetchOperationsWithFilter;
